import React from 'react'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

const ExplanationComp = () => (
  <div>
    <div style={{textAlign: 'left', marginTop: 20, padding: '0'}}>
      <Typography variant="title" color='caption'>
        Historia Argentina. Sucesos
      </Typography>
      <Divider style={{ backgroundColor: '#9E9E9E', opacity: '0.3', margin: 20, }}/>
    </div>
    <Typography variant="body2" color='caption' style={{marginBottom: 10}}>
      Esta sección hace referencia a los sucesos más importantes que ocurrieron a
      lo largo del tiempo en Argentina. Aquí intentamos resumir de la mejor manera
      (es decir sin excluir hechos relevantes) aquellos momentos que fueron determinantes
      para ir construyendo la identidad argentina.
    </Typography>
    <Typography variant="body2" color='caption' style={{marginBottom: 10}}>
      Se puede apreciar una primera división en base a los momentos que determinaron un cambio
      o que produjeron "ésa" situación significativa que todos recuerdan.
      Si bien es sabido que los años no son lo más importante en historia, es necesario usarlos
      como una guía rápida para encontrar de la manera más corta, lo que se está buscando.
    </Typography>
    <Typography variant="body2" color='caption' style={{marginBottom: 10}}>
      Hay una primera división hecha en años/sucesos. Luego, cada una de estas divisiones, a su vez,
      se encuentra fragmentada en las siguientes secciones: Política Interna, Política Externa, Economía, Sociedad y Cultura.
    </Typography>
  </div>
)

export default ExplanationComp



// WEBPACK FOOTER //
// ./src/components/explanation.js